import script from "./FooterLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterLanding.vue?vue&type=script&setup=true&lang=js"

import "./FooterLanding.vue?vue&type=style&index=0&id=409043de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-409043de"]])

export default __exports__